export var mediaBreakpointUp = function mediaBreakpointUp(breakpoint, styles) {
  if (styles) {
    if (breakpoint) {
      return "@media (min-width: ".concat(breakpoint, "px){").concat(styles, "}");
    } else if (breakpoint === 0) {
      return styles;
    }
  }
  return '';
};